module.exports = __webpack_public_path__ + "img/OKRComment.9ea70c65.png";